module.exports = __webpack_public_path__ + "media/new/contact-join-bf5829f2.png";